export enum CardStates {
  REQUEST_PRICE,
  AVAILABLE,
  NOT_AVAILABLE,
}
